/** SpacetimeCatalogDto (GET /{context}/spacetime/catalog), member-cased like every other v2 response. */
export enum SpacetimeInsightStatus {
    /** Card, explainer and the insight itself. */
    Unlocked = 1,
    /** Card and explainer only. */
    Locked = 2,
    /** Only Flip.to staff see the card; the server already drops these for hoteliers. */
    FliptoOnly = 3,
}

export interface SpacetimeCatalogInsight {
    Key: string;
    Status: SpacetimeInsightStatus;
    /** Unlocked after launch and this user has not opened its explainer yet. */
    IsNew: boolean;
}

export interface SpacetimeCatalog {
    Insights: SpacetimeCatalogInsight[];
    /** Pinned insight keys in nav order; the default when the user has no unlocked pin. */
    Pins: string[];
    /** Up to five unpinned, unlocked insights the user opened, latest first. */
    RecentlyViewed: string[];
}
